import { render, staticRenderFns } from "./CenterLayout.vue?vue&type=template&id=78dafa73&scoped=true"
import script from "./CenterLayout.vue?vue&type=script&lang=js"
export * from "./CenterLayout.vue?vue&type=script&lang=js"
import style0 from "./CenterLayout.vue?vue&type=style&index=0&id=78dafa73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dafa73",
  null
  
)

export default component.exports